import React from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom';

export default function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  